import { AccountCircle, CodeOutlined, Contacts, Edit, HistoryEdu, Info, SchoolOutlined, WorkOutline } from '@mui/icons-material';
import { Box, Button, Card, CardActionArea, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Fab, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Container } from '@mui/system';
import { Unsubscribe } from 'firebase/auth';
import { Timestamp, doc, getDoc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import truncate from 'lodash.truncate';
import { Moment } from 'moment';
import React, { FC, Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getStatusValue } from '../../common/utils';
import { UserType } from '../../consts/types/general';
import { JobStatus, PersonalTabs, UserInfo, UserJob } from '../../consts/types/user';
import { db } from '../../firebase';
import { authActionsCreators } from '../../reducers/auth';
import { UserSelectors, userActionsCreators } from '../../reducers/user';
import AppBarComp from '../AppBarComp';
import LinearProgressWithLabel from '../Common/LinearProgressWithLabel';
import CandidateCard from '../Employer/CandidateCard';
import Login from '../Login';
import AddEducationDialog from './Dialogs/AddEducationDialog';
import AddExperienceDialog from './Dialogs/AddExperienceDialog';
import AddRecommenderDialog from './Dialogs/AddRecommenderDialog';
import AddSkillDialog from './Dialogs/AddSkillDialog';
import AddSocialDialog from './Dialogs/AddSocialDialog';
import EditPersonalDialog from './Dialogs/EditPersonalDialog';
import Experience from './Experience';
import Recommendations from './Recommendations';
import Skills from './Skills';
import UserSocial from './Social';


enum UserTabs {
    Jobs,
    FollowUp
}
interface DashboardProps {

}

type Props = DashboardProps;

const statuses = Object.values(JobStatus);

const Dashboard: FC<Props> = (props: Props) => {
    const user = useSelector(UserSelectors.currentUser);
    const [tab, setTab] = useState(0);
    const [jobs, setJobs] = useState<UserJob[]>([]);
    const [scheduleVideoDialogJob, setScheduleVideoDialogJob] = useState<UserJob | null>(null);
    const [scheduleFrontalDialogJob, setScheduleFrontalDialogJob] = useState<UserJob | null>(null);
    const [date, setDate] = useState<Moment | null>(null);
    const [isSavingVideo, setIsSavingVideo] = useState(false);
    const [isSavingFrontal, setIsSavingFrontal] = useState(false);
    const [selectedFrontalChip, setSelectedFrontalChip] = useState<Timestamp | null>(null);
    const [placeJob, setPlaceJob] = useState<UserJob | null>(null);
    const [isSavingEducation, setIsSavingEducation] = useState(false);
    const [isAddingEducation, setIsAddingEducation] = useState(false);
    const [isAddingExperience, setIsAddingExperience] = useState(false);
    const [isSavingExperience, setIsSavingExperience] = useState(false);
    const [isSavingSkills, setIsSavingSkills] = useState(false);
    const [isAddingSkill, setIsAddingSkills] = useState(false);
    const [isSavingSocial, setIsSavingSocial] = useState(false);
    const [isAddingSocial, setIsAddingSocial] = useState(false);
    const [isSavingRecommender, setIsSavingRecommender] = useState(false);
    const [isAddingRecommender, setIsAddingRecommender] = useState(false);
    const [isEditingPersonal, setIsEditingPersonal] = useState(false);
    const [personalTab, setPersonalTab] = useState(PersonalTabs.Personal);
    const [showMore, setShowMore] = useState(false);
    const [infoDialogOpen, setInfoDialogOpen] = useState(false);
    const [profileCardDialogOpen, setProfileCardDialogOpen] = useState(false);

    const theme = useTheme();
    const downMD = useMediaQuery(theme.breakpoints.down('md'));

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        let unsub: Unsubscribe | null = null;
        let unsubJobs: Unsubscribe | null = null;
        if (user) {
            unsub = onSnapshot(doc(db, "users", user.email,), (doc) => {
                dispatch(userActionsCreators.setUser({
                    user: { ...doc.data() as UserInfo, }
                }));
            });
            unsubJobs = onSnapshot(doc(db, "jobs", user.email,), (doc) => {
                setJobs((doc.data() as any).interviews);
            });
        }
        return () => {
            if (unsub) {
                unsub();
            }
            if (unsubJobs) {
                unsubJobs();
            }
        }
    }, [user?.email]); //eslint-disable-line

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    };

    const handleDateChange = (newValue: Moment | null) => {
        setDate(newValue);
    };


    const onLoginSuccess = (authResult: any) => {
        if (authResult.additionalUserInfo.isNewUser) {
            setDoc(doc(db, "users", authResult.user.email), {
                name: authResult.user.displayName,
                phone: authResult.user.phoneNumber,
                email: authResult.user.email,
                title: "",
                // approved: false,
                experienceYears: 0,
                status: "Filling Profile",
                area: "",
                city: "",
                degrees: [],
                education: [],
                experience: [],
                recommenders: [],
                skills: [],
                skillsNames: [],
                social: [],
                skillsTestLink: "",
                testGrade: 0,
                largeCompanies: false,
                startup: false,
                management: false,
                description: "",
                salary: "",
                age: null,
                notifyOnAllJobs: false,
                car: false,
                personality: {},
                field: "" as any,
                ides: [],
                profileViews: 0,
                metadata: { creationTime: serverTimestamp() as any }
            } as UserInfo)
                .then(async () => {
                    const docRef = doc(db, "users", authResult.user.email);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        dispatch(authActionsCreators.setUserType({
                            type: UserType.User
                        }));
                        dispatch(userActionsCreators.setUser({
                            user: { ...docSnap.data() as UserInfo, }
                        }));
                    }
                    else {
                        dispatch(userActionsCreators.setUser({ user: null }));
                    }
                })
                .catch(() => { });
        }
        return false;
    }

    // const scheduleVideoInterview = () => {
    //     const job = scheduleVideoDialogJob;
    //     if (user && date && job) {
    //         setIsSavingVideo(true);
    //         setDoc(doc(db, "jobs", user.email), {
    //             interviews: jobs.map(j => {
    //                 if (j.email === job.email && j.company === job.company) {
    //                     return { ...j, firstInterviewDate: Timestamp.fromDate(date.toDate()) }
    //                 }
    //             })

    //         }, { merge: true })
    //             .then((result) => {
    //                 setIsSavingVideo(false);
    //                 setScheduleVideoDialogJob(null);
    //                 setDate(null);
    //                 // NotificationManager.success('Invitation was sent successfully!',);
    //                 // onClose();
    //             })
    //             .catch(() => {
    //                 setIsSavingVideo(false);
    //                 setScheduleVideoDialogJob(null);
    //                 setDate(null);
    //                 // NotificationManager.error('An error occurred. Please try again.',);
    //             });

    //     }


    // }
    // const scheduleFrontalInterview = () => {
    //     const job = scheduleFrontalDialogJob;
    //     if (user && selectedFrontalChip && job) {
    //         setIsSavingFrontal(true);
    //         setDoc(doc(db, "jobs", user.email), {
    //             interviews: jobs.map(j => {
    //                 if (j.email === job.email && j.company === job.company) {
    //                     return { ...j, secondInterviewDate: selectedFrontalChip }
    //                 }
    //             })

    //         }, { merge: true })
    //             .then((result) => {
    //                 setIsSavingFrontal(false);
    //                 setScheduleFrontalDialogJob(null);
    //                 setSelectedFrontalChip(null);
    //                 // NotificationManager.success('Invitation was sent successfully!',);
    //                 // onClose();
    //             })
    //             .catch(() => {
    //                 setIsSavingFrontal(false);
    //                 setScheduleFrontalDialogJob(null);
    //                 setSelectedFrontalChip(null);
    //                 // NotificationManager.error('An error occurred. Please try again.',);
    //             });

    //     }


    // }

    const getStatusColor = () => {
        const score = getStatusValue();
        if (score <= 50) {
            return "warning";
        }
        else if (score <= 70) {
            return "inherit";
        }
        else if (score === 90) {
            return "info";
        }
        else {
            return "success";
        }
    }

    // const getStatusTextColor = () => {
    //     const status = getStatusValue();
    //     if (status <= 50) {
    //         return "#ed6c02";
    //     }
    //     if (status < 70) {
    //         return "inherit";
    //     }
    //     else if (status === 90) {
    //         return "#0288d1";
    //     }
    //     else if (user?.approved) {
    //         return "#2e7d32";
    //     }
    // }

    return <Box height={{ xs: "initial", md: "100vh" }} minHeight="100vh" display="flex" flexDirection="column" sx={{ backgroundColor: "#f5f5f5" }} overflow="auto">
        <AppBarComp />
        <Container maxWidth="md" sx={{ display: "flex", flexDirection: "column", flex: 1, pt: 3, pb: { xs: "60px", md: "0" } }} >

            <Box display="flex" height="100%" gap={2} flexDirection={{ xs: "column", md: "column" }} pb={7}>
                {user === null && <Box display="flex" justifyContent="center" alignItems="baseline" flex={1} >
                    <Box padding={3} minHeight="30vh" minWidth="20vw" sx={{ background: "white", borderRadius: "8px", boxShadow: "0px 1px 5px rgb(32 38 74 / 15%)" }} mt={5}>
                        <Typography fontSize={{ xs: "1.5rem", md: "2rem" }} textAlign="center" fontWeight={500} mb={5}>Sign in</Typography>
                        <Login onSuccess={onLoginSuccess} />
                    </Box>

                </Box>
                }
                {user && <Fragment>
                    <Card variant="outlined" sx={{ py: 2, px: 2, justifyContent: "space-between", display: "flex", alignItems:"center" }} >
                        <Box alignItems="center" gap={{ xs: 1, md: 2 }} display="flex" px={1} >
                            <Typography fontSize={{ xs: "0.875rem", md: "0.9rem" }}> Profile</Typography>
                            <Box width={{ xs: "50vw", md: "20vw" }}>
                                <LinearProgressWithLabel value={getStatusValue()} color={getStatusColor()} sx={{ height: { xs: "15px", md: "8px" }, borderRadius: "50px" }} />
                            </Box>
                        </Box>
                        <IconButton color="default" onClick={() => { setInfoDialogOpen(true) }}>
                            <Info />
                        </IconButton>

                    </Card>
                    <Box flex={{ xs: 1, md: 0.6 }} display={{ xs: "none", md: "flex" }} flexDirection="column" gap={3} >
                        <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>
                            <Card sx={{ flex: 1, height: "max-content", color: "palevioletred", borderColor: "palevioletred" }} variant="outlined" onClick={() => { setIsAddingEducation(true) }}>
                                <CardActionArea sx={{ paddingY: 1 }}>
                                    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
                                        <Box color="palevioletred">
                                            <SchoolOutlined sx={{ fontSize: { xs: "1.6rem", md: "1.7rem" } }} color="inherit" />
                                        </Box>
                                        <Box>
                                            <Typography fontWeight={500} fontSize="0.92rem">Add Education</Typography>
                                        </Box>
                                    </Box>
                                </CardActionArea>
                            </Card>
                            <Card sx={{ flex: 1, height: "max-content", color: "cornflowerblue", borderColor: "cornflowerblue" }} variant="outlined">
                                <CardActionArea sx={{ paddingY: 1 }} onClick={() => { setIsAddingSkills(true) }}>
                                    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
                                        <Box color="cornflowerblue">
                                            <CodeOutlined sx={{ fontSize: { xs: "1.6rem", md: "1.7rem" } }} color="inherit" />
                                        </Box>
                                        <Box>
                                            <Typography fontWeight={500} fontSize="0.92rem">Add Skill</Typography>
                                        </Box>
                                    </Box>
                                </CardActionArea>
                            </Card>
                            <Card sx={{ flex: 1, height: "max-content", color: "orange", borderColor: "orange" }} variant="outlined">
                                <CardActionArea sx={{ paddingY: 1 }} onClick={() => { setIsAddingExperience(true) }}>
                                    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
                                        <Box color="orange">
                                            <WorkOutline sx={{ fontSize: { xs: "1.6rem", md: "1.7rem" } }} color="inherit" />
                                        </Box>
                                        <Box>
                                            <Typography fontWeight={500} fontSize="0.92rem">Add Experience</Typography>
                                        </Box>
                                    </Box>
                                </CardActionArea>
                            </Card>

                        </Box>
                        {/* <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>

                            <Card sx={{ flex: 1, height: "max-content", color: "#1976d2", borderColor: "#1976d2" }} variant="outlined">
                                <CardActionArea sx={{ paddingY: 1 }} onClick={() => { setIsAddingSocial(true) }}>
                                    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
                                        <Box color="#1976d2">
                                            <LinkedIn sx={{ fontSize: { xs: "1.6rem", md: "1.7rem" } }} color="inherit" />
                                        </Box>
                                        <Box>
                                            <Typography fontWeight={500} fontSize="0.92rem">Add Social Accounts</Typography>
                                        </Box>
                                    </Box>
                                </CardActionArea>
                            </Card>
                            <Card sx={{ flex: 1, height: "max-content", color: "lightseagreen", borderColor: "lightseagreen" }} variant="outlined">
                                <CardActionArea sx={{ paddingY: 1 }} onClick={() => { setIsAddingRecommender(true) }}>
                                    <Box display="flex" gap={2} alignItems="center" justifyContent="center">
                                        <Box color="lightseagreen">
                                            <PeopleAltOutlined sx={{ fontSize: { xs: "1.6rem", md: "1.7rem" } }} color="inherit" />
                                        </Box>
                                        <Box>
                                            <Typography fontWeight={500} fontSize="0.92rem">Add Recommenders</Typography>
                                        </Box>
                                    </Box>
                                </CardActionArea>
                            </Card>
                        </Box> */}

                    </Box>
                    <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2} >
                        <Card variant="outlined" sx={{ flex: { xs: 1, md: 0.5 }, position: "relative" }}>
                            <CardHeader avatar={<AccountCircle fontSize="large" />
                                // <AvatarComponent
                                //     style={{ width: '70px', height: '70px', fill: "red" }}
                                //     avatarStyle='Circle'
                                //     topType='WinterHat2'
                                //     accessoriesType='Prescription02'
                                //     hairColor='BrownDark'
                                //     facialHairType='Blank'
                                //     clotheType='Hoodie'
                                //     clotheColor='Blue03'
                                //     eyeType='Happy'
                                //     eyebrowType='Default'
                                //     mouthType='Smile'
                                //     skinColor='Light'


                                // />
                            } title={user.name}
                                subheader={user.title || "Your Title"}
                                action={<IconButton onClick={() => { setPersonalTab(PersonalTabs.Personal); setIsEditingPersonal(true) }}>
                                    <Edit />
                                </IconButton>} />
                            <CardContent sx={{ paddingBottom: "16px !important" }}>
                                <Typography variant="caption" color="text.secondary">Email</Typography>
                                <Typography mb={1} >{user.email}</Typography>
                                {(user.city || user.area) && <Typography variant="caption" color="text.secondary">{user.city ? "City" : "Area"}</Typography>}
                                {(user.city || user.area) && <Typography mb={1} >{user.city || user.area}</Typography>}
                                <Typography variant="caption" color="text.secondary">Phone Number</Typography>
                                <Typography >{user.phone || "Your Phone Number"}</Typography>
                            </CardContent>

                        </Card>
                        <Card variant="outlined" sx={{ flex: { xs: 1, md: 0.5 }, position: "relative" }}>
                            <CardHeader title="About" subheader="Professional and personal description"
                                avatar={<HistoryEdu fontSize="large" />}
                                action={<IconButton onClick={() => { setPersonalTab(PersonalTabs.Description); setIsEditingPersonal(true) }}>
                                    <Edit />
                                </IconButton>} />
                            <CardContent sx={{ paddingBottom: "16px !important" }}>
                                {/* <Typography fontSize="1.2rem" color="text.secondary">About</Typography> */}
                                {/* <Typography mb={1} fontSize="0.9rem">{user.description}</Typography> */}
                                {!user.description && <Typography color="darkgray">Something like: Junior developer with a BS.c in Computer Science. Looking for my next challenge.</Typography>}
                                {user.description && <Typography mb={1} sx={{ whiteSpace: "break-spaces", wordBreak: "break-word" }}>
                                    {showMore ? user.description.trimEnd() : truncate(user.description, { length: 280 }).trimEnd()}
                                    {user.description.length > 280 && <Button size="small" sx={{ fontSize: { xs: "0.6rem", md: "0.65rem" }, fontWeight: "bold" }} color="inherit" onClick={() => { setShowMore(!showMore) }}>
                                        {showMore ? "show less" : "show more"}
                                    </Button>}
                                </Typography>}

                            </CardContent>

                        </Card>



                    </Box>

                    <Box display="flex" gap={2} flexDirection="column">
                        <Experience />
                        <Skills />
                        <UserSocial />
                        <Recommendations />
                    </Box>
                </Fragment>}
                <AddEducationDialog isAddingEducation={isAddingEducation}
                    isSavingEducation={isSavingEducation}
                    setIsAddingEducation={setIsAddingEducation}
                    setIsSavingEducation={setIsSavingEducation}
                />
                <AddExperienceDialog isAddingExperience={isAddingExperience}
                    isSavingExperience={isSavingExperience}
                    setIsAddingExperience={setIsAddingExperience}
                    setIsSavingExperience={setIsSavingExperience}
                />
                <AddSkillDialog isAddingSkill={isAddingSkill}
                    isSavingSkills={isSavingSkills}
                    setIsAddingSkills={setIsAddingSkills}
                    setIsSavingSkills={setIsSavingSkills} />
                <AddSocialDialog isAddingSocial={isAddingSocial}
                    isSavingSocial={isSavingSocial}
                    setIsAddingSocial={setIsAddingSocial}
                    setIsSavingSocial={setIsSavingSocial} />
                <AddRecommenderDialog isAddingRecommender={isAddingRecommender}
                    isSavingRecommender={isSavingRecommender}
                    setIsAddingRecommender={setIsAddingRecommender}
                    setIsSavingRecommender={setIsSavingRecommender} />
                <EditPersonalDialog tab={personalTab} isOpen={isEditingPersonal} onClose={() => { setIsEditingPersonal(false) }} />
                <Dialog fullScreen={downMD} open={infoDialogOpen} onClose={() => { setInfoDialogOpen(false) }}>
                    <DialogTitle>Profile Score</DialogTitle>
                    <DialogContent sx={{ lineHeight: "1.7rem" }}>
                        Profile score is calculated using all parts of the profile.
                        <br />Base score is 100%, each part is considered for the final result:
                        <br />1)&nbsp;&nbsp;<strong>Personal details</strong> {"->"} 10%
                        <br />2)&nbsp;&nbsp;<strong>Education and Experience </strong> {"->"} 20%, experience is optional
                        <br />3)&nbsp;&nbsp;<strong>Skills</strong> {"->"} 20%
                        <br />4)&nbsp;&nbsp;<strong>Recommenders</strong> {"->"} 10%
                        <br />5)&nbsp;&nbsp;<strong>Social Accounts</strong> {"->"} 10%
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setInfoDialogOpen(false) }}>Close</Button>
                    </DialogActions>
                </Dialog>
                {user && <Dialog fullScreen={downMD} maxWidth="md" fullWidth open={profileCardDialogOpen} onClose={() => { setProfileCardDialogOpen(false) }}>
                    <DialogTitle>Profile Card</DialogTitle>
                    <DialogContent sx={{ lineHeight: "1.7rem" }}>
                        <Typography mb={1} fontSize="0.95rem">Take a look at how <strong>employers see your profile</strong> card.</Typography>
                        <Typography mb={4} fontSize="0.95rem">Add title, description and experience to make your card stand out!</Typography>
                        <CandidateCard candidate={user} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setProfileCardDialogOpen(false) }}>Close</Button>
                    </DialogActions>
                </Dialog>}
            </Box>
            <Fab color="primary" onClick={() => { setProfileCardDialogOpen(true) }} sx={{ position: "fixed", right: { xs: 8, md: "50%" }, bottom: 16, marginRight: { xs: 0, md: "-500px" } }}>
                <Contacts />
            </Fab>
        </Container >

    </Box >
        ;
}


export default Dashboard;

